import React, { Component } from 'react'
import ReactSVG from 'react-svg'

import './icon.scss'

/**
 * Renders regular image or svg icons. 2 icon sources can be specified to overlay one on top of another.
 * Supports 4 render sizes as follows:
 * - l  - Large  (48x48)
 * - m  - Medium (32x32)
 * - s  - Small  (24x24)
 * - xs - extra small (20x20)
 * - t  - Tiny   (16x16)
 *
 * Look at default props for reference.
 */
class Icon extends Component {
  onClick (e) {
    // console.log('Icon onClick triggered!', e)
    if (this.props.onClick) {
      this.props.onClick(e)
    }
  }

  getSizeClass () {
    switch (this.props.size) {
      case undefined:
      case null:
      case 'l':
        return ' size-large'
      case 'm':
        return ' size-medium'
      case 's':
        return ' size-small'
      case 'xs':
        return ' size-x-small'
      case 't':
        return ' size-tiny'   // (used for ex. help icon which can be 16x16)
    }
  }

  render () {
    let css = 'element-icon' + this.getSizeClass()
    if (this.props.onClick) {
      css += ' clickable'
    }
    if (this.props.className) {
      css += ' ' + this.props.className
    }

    const renderIcon = (icon, number) => {
      if (!icon || !icon.fileName || icon.fileName === '') return null
      if (icon.fileName === undefined) {
        console.error('Invalid format of icon!: ', icon, 'Expects { fileName: "..." }')
        return null
      }
      // let style = {
      //   left: icon.xOffset,
      //   top: icon.yOffset
      // }
      let iconStyle = {
        left: icon.xOffset,
        top: icon.yOffset
      }
      if (!isNaN(this.props.rotation) && this.props.rotation !== 0) {
        iconStyle.transform = `rotate(${this.props.rotation}deg)`
      }
      // Added this only for Rental Car Overview, to overwrite with inline style when necessary
      let style = Object.assign(iconStyle, this.props.style)

      if (icon.width !== undefined && icon.width !== null) {
        style.width = icon.width
      }
      if (icon.height !== undefined && icon.height !== null) {
        style.height = icon.height
      }

      let imgCss = `img${number} ${this.props.imgClassName}`

      // Render with click through for svg icons when no click handler is provided.
      var clickThrough = ' click-through'
      if (typeof this.props.onClick === 'function') {
        clickThrough = ''
      }

      // Render as svg or regular img tag?
      if (icon.fileName.endsWith('.svg') && this.props.injectSvg) {
        const emptyCb = () => {}
        const setStyleCb = (svg) => {
          svg.setAttribute('style', icon.svgStyle)
        }

        return (
          <div className={imgCss + clickThrough} style={style} onClick={this.onClick.bind(this)}>
            <ReactSVG src={icon.fileName} beforeInjection={typeof icon.svgStyle === 'string' ? setStyleCb : emptyCb} />
          </div>
        )
      }
      return (
        <img src={icon.fileName} className={imgCss} style={style} onClick={this.onClick.bind(this)} />
      )
    }

    let ariaClass = ''
    if (this.props.ariaText !== null) {
      ariaClass = ' hint--' + this.props.ariaPos
    }
    return (
      <div className={css + ariaClass} aria-label={this.props.ariaText}>
        {renderIcon(this.props.icon, 1)}
        {renderIcon(this.props.icon2, 2)}
      </div>
    )
  }
}

Icon.defaultProps = {
  size: 's',      // t: 16px, xs: 20px s: 24px, m: 32px, l: 48px
  icon: { fileName: null, xOffset: 0, yOffset: 0 },
  icon2: null,    // Icon2 acts as an overlay
  className: '',  // css class for svgs
  injectSvg: false,
  imgClassName: '',
  ariaText: null,
  ariaPos: 'left',
  rotation: 0
  // onClick: null
}

export default Icon



// WEBPACK FOOTER //
// ./src/app/shared/elements/icon/index.js